/*
 * Haulex scroll fade-in.
 *
 * Elements marked .hx-fade-in start faded and slightly low, then transition
 * into place the first time they enter the viewport. Observation stops after
 * an element has been revealed, so scrolling back up does not re-trigger it.
 *
 * A parent marked .hx-fade-in-grid staggers its direct children: child N is
 * delayed N * 100ms, capped at 500ms so a long grid never feels slow.
 *
 * The initial hidden state is applied by this script rather than by the
 * stylesheet. If the JS fails to load the content stays plainly visible
 * instead of being stranded at opacity 0.
 *
 * prefers-reduced-motion: no observers, no transitions, everything visible.
 */
(function () {
  if (window.__hxAnimationsLoaded) return;
  window.__hxAnimationsLoaded = true;

  var STEP_MS = 100;
  var MAX_DELAY_MS = 500;
  var THRESHOLD = 0.08;

  function init() {
    var targets = document.querySelectorAll('.hx-fade-in');
    if (!targets.length) return;

    var reduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // No IntersectionObserver (or reduced motion): reveal everything at once.
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('hx-fade-in--visible'); });
      document.documentElement.classList.add('hx-fade-ready');
      return;
    }

    // Marks the document so the stylesheet knows the hidden state is safe to
    // apply — set before observing so nothing flashes in first.
    document.documentElement.classList.add('hx-fade-ready');

    // Stagger is assigned per grid, not globally, so each grid counts from 0.
    document.querySelectorAll('.hx-fade-in-grid').forEach(function (grid) {
      var i = 0;
      Array.prototype.forEach.call(grid.children, function (child) {
        if (!child.classList.contains('hx-fade-in')) return;
        var delay = Math.min(i * STEP_MS, MAX_DELAY_MS);
        child.style.transitionDelay = delay + 'ms';
        i++;
      });
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('hx-fade-in--visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: THRESHOLD }
    );

    targets.forEach(function (el) {
      // Anything already on screen at load is revealed without waiting for a
      // scroll event, which matters for above-the-fold content.
      var box = el.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) {
        el.classList.add('hx-fade-in--visible');
        return;
      }
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-scan when the theme editor swaps a section in. */
  document.addEventListener('shopify:section:load', init);
})();
